import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseAlertComponent } from '../../../../../../@fuse/components/alert';
import { FuseCardComponent } from '../../../../../../@fuse/components/card';

@Component({
    selector: 'app-microsoft-redirect-error',
    templateUrl: './microsoft-redirect-error.component.html',
    imports: [FuseCardComponent, FuseAlertComponent, MatButtonModule, MatIconModule],
})
export class MicrosoftRedirectErrorComponent {}
